import {
  FORM_STATUS_LIST,
  FORM_STATUS_LIST_SUCCESS,
  FORM_STATUS_LIST_FAILURE,
  FORM_STATUS_CREATE,
  FORM_STATUS_CREATE_SUCCESS,
  FORM_STATUS_CREATE_FAILURE,
  FORM_STATUS_UPDATE,
  FORM_STATUS_UPDATE_SUCCESS,
  FORM_STATUS_UPDATE_FAILURE,
  FORM_STATUS_DELETE,
  FORM_STATUS_DELETE_SUCCESS,
  FORM_STATUS_DELETE_FAILURE,
  FORMS_SET_STATUS,
  FORMS_SET_STATUS_SUCCESS,
  FORMS_SET_STATUS_FAILURE,
  FORMS_LIST,
  FORMS_LIST_SUCCESS,
  FORMS_LIST_FAILURE,
  FORMS_RENDER,
  FORMS_RENDER_SUCCESS,
  FORMS_RENDER_FAILURE,
  FORMS_SAVE,
  FORMS_SAVE_SUCCESS,
  FORMS_SAVE_FAILURE,
  FORMS_PUBLISH,
  FORMS_PUBLISH_SUCCESS,
  FORMS_PUBLISH_FAILURE,
  FORMS_UNPUBLISH,
  FORMS_UNPUBLISH_SUCCESS,
  FORMS_UNPUBLISH_FAILURE,
  FORMS_DUPLICATE,
  FORMS_DUPLICATE_SUCCESS,
  FORMS_DUPLICATE_FAILURE,
  FORMS_DELETE,
  FORMS_DELETE_SUCCESS,
  FORMS_DELETE_FAILURE,
  FORMS_SUBMISSIONS,
  FORMS_SUBMISSIONS_SUCCESS,
  FORMS_SUBMISSIONS_FAILURE,
  FORMS_SUBMISSION_DATA,
  FORMS_SUBMISSION_DATA_SUCCESS,
  FORMS_SUBMISSION_DATA_FAILURE,
} from "./actionType";

// List forms
export const listForms = () => {
  return {
    type: FORMS_LIST,
  };
};

export const listFormsSuccess = (formsList) => {
  return {
    type: FORMS_LIST_SUCCESS,
    payload: formsList,
  };
};

export const listFormsFailure = (error) => {
  return {
    type: FORMS_LIST_FAILURE,
    payload: error,
  };
};

// Render one form (full nested bundle) - payload = { id }
export const renderForm = (data) => {
  return {
    type: FORMS_RENDER,
    payload: data,
  };
};

export const renderFormSuccess = (form) => {
  return {
    type: FORMS_RENDER_SUCCESS,
    payload: form,
  };
};

export const renderFormFailure = (error) => {
  return {
    type: FORMS_RENDER_FAILURE,
    payload: error,
  };
};

// Save (create when no Id, update when Id present) - single object w/ nested lists
export const saveForm = (form) => {
  return {
    type: FORMS_SAVE,
    payload: form,
  };
};

export const saveFormSuccess = (form) => {
  return {
    type: FORMS_SAVE_SUCCESS,
    payload: form,
  };
};

export const saveFormFailure = (error) => {
  return {
    type: FORMS_SAVE_FAILURE,
    payload: error,
  };
};

// Publish - payload = { Form_Id }
export const publishForm = (data) => {
  return {
    type: FORMS_PUBLISH,
    payload: data,
  };
};

export const publishFormSuccess = (form) => {
  return {
    type: FORMS_PUBLISH_SUCCESS,
    payload: form,
  };
};

export const publishFormFailure = (error) => {
  return {
    type: FORMS_PUBLISH_FAILURE,
    payload: error,
  };
};

// Unpublish - payload = { Form_Id }
export const unpublishForm = (data) => {
  return {
    type: FORMS_UNPUBLISH,
    payload: data,
  };
};

export const unpublishFormSuccess = (form) => {
  return {
    type: FORMS_UNPUBLISH_SUCCESS,
    payload: form,
  };
};

export const unpublishFormFailure = (error) => {
  return {
    type: FORMS_UNPUBLISH_FAILURE,
    payload: error,
  };
};

// Duplicate - payload = { id: Form_Id }
export const duplicateForm = (data) => {
  return {
    type: FORMS_DUPLICATE,
    payload: data,
  };
};

export const duplicateFormSuccess = (form) => {
  return {
    type: FORMS_DUPLICATE_SUCCESS,
    payload: form,
  };
};

export const duplicateFormFailure = (error) => {
  return {
    type: FORMS_DUPLICATE_FAILURE,
    payload: error,
  };
};

// Delete - payload = [Id, ...]
export const deleteForms = (ids) => {
  return {
    type: FORMS_DELETE,
    payload: ids,
  };
};

export const deleteFormsSuccess = (ids) => {
  return {
    type: FORMS_DELETE_SUCCESS,
    payload: ids,
  };
};

export const deleteFormsFailure = (error) => {
  return {
    type: FORMS_DELETE_FAILURE,
    payload: error,
  };
};

// Submissions list for a form - payload = { id: Form_Id }
export const listFormSubmissions = (data) => {
  return {
    type: FORMS_SUBMISSIONS,
    payload: data,
  };
};

export const listFormSubmissionsSuccess = (submissions) => {
  return {
    type: FORMS_SUBMISSIONS_SUCCESS,
    payload: submissions,
  };
};

export const listFormSubmissionsFailure = (error) => {
  return {
    type: FORMS_SUBMISSIONS_FAILURE,
    payload: error,
  };
};

// Single submission (with values + files) - payload = { id: FormSubmission_Id }
export const getFormSubmissionData = (data) => {
  return {
    type: FORMS_SUBMISSION_DATA,
    payload: data,
  };
};

export const getFormSubmissionDataSuccess = (submission) => {
  return {
    type: FORMS_SUBMISSION_DATA_SUCCESS,
    payload: submission,
  };
};

export const getFormSubmissionDataFailure = (error) => {
  return {
    type: FORMS_SUBMISSION_DATA_FAILURE,
    payload: error,
  };
};


// Task 24888 - the company's own form statuses.
export const formStatusList = (data) => ({
  type: FORM_STATUS_LIST,
  payload: data,
});

export const formStatusListSuccess = (data) => ({
  type: FORM_STATUS_LIST_SUCCESS,
  payload: data,
});

export const formStatusListFailure = (data) => ({
  type: FORM_STATUS_LIST_FAILURE,
  payload: data,
});

export const formStatusCreate = (data) => ({
  type: FORM_STATUS_CREATE,
  payload: data,
});

export const formStatusCreateSuccess = (data) => ({
  type: FORM_STATUS_CREATE_SUCCESS,
  payload: data,
});

export const formStatusCreateFailure = (data) => ({
  type: FORM_STATUS_CREATE_FAILURE,
  payload: data,
});

export const formStatusUpdate = (data) => ({
  type: FORM_STATUS_UPDATE,
  payload: data,
});

export const formStatusUpdateSuccess = (data) => ({
  type: FORM_STATUS_UPDATE_SUCCESS,
  payload: data,
});

export const formStatusUpdateFailure = (data) => ({
  type: FORM_STATUS_UPDATE_FAILURE,
  payload: data,
});

export const formStatusDelete = (data) => ({
  type: FORM_STATUS_DELETE,
  payload: data,
});

export const formStatusDeleteSuccess = (data) => ({
  type: FORM_STATUS_DELETE_SUCCESS,
  payload: data,
});

export const formStatusDeleteFailure = (data) => ({
  type: FORM_STATUS_DELETE_FAILURE,
  payload: data,
});

export const setFormStatus = (data) => ({
  type: FORMS_SET_STATUS,
  payload: data,
});

export const setFormStatusSuccess = (data) => ({
  type: FORMS_SET_STATUS_SUCCESS,
  payload: data,
});

export const setFormStatusFailure = (data) => ({
  type: FORMS_SET_STATUS_FAILURE,
  payload: data,
});

